import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FollowersCounterPaddingDirective } from './followers-counter-padding.directive';

@Component({
  selector: 'rt-total-followers-counter',
  template: `{{ count() }}`,
  styleUrls: ['./followers-counter.component.less'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.has-outline]': 'hasOutline()',
  },
  hostDirectives: [
    {
      directive: FollowersCounterPaddingDirective,
      inputs: ['rtFollowersCounterPadding: count', 'rtFollowersCounterPaddingEnabled: hasOutline'],
    },
  ],
})
export class FollowersCounterComponent {
  public readonly count = input<number>(0);

  public readonly hasOutline = input<boolean>(true);
}
